import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormArray, FormGroup, AbstractControl } from '@angular/forms';
import { Observable, throwError, merge, EMPTY } from 'rxjs';
import { map, distinct, mapTo, catchError, retry } from 'rxjs/operators';
import { Event, Partner } from '@app/shared/_models/common';
import { Product, ProductTpl, Packaging, ProductPackagingVal } from '@app/shared/_models/product';
import * as constants from '@app/shared/constants';

import { environment } from '@app/../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InvoiceCreationService {
  constructor(private http: HttpClient) {}

  getDeliveriesToInvoice(): Observable<any> {
    return this.http.get<any>(environment.server_url + '/sales/deliveriestoinvoice');
  }
}
